var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMilitaryLight = function SvgIconMilitaryLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_military_light_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#121619"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.4 11.78-1.51 3.102a1.1 1.1 0 0 1-.838.608l-3.41.476 2.423 2.344a1.1 1.1 0 0 1 .32.967l-.556 3.418 3.07-1.573a1.1 1.1 0 0 1 1.003 0l3.069 1.573-.556-3.418a1.1 1.1 0 0 1 .32-.967l2.433-2.354-3.416-.466a1.1 1.1 0 0 1-.84-.608L24.4 11.78Zm1.603-1.734a1.689 1.689 0 0 0-1.565-1.02 1.849 1.849 0 0 0-1.627.993l-1.643 3.373-3.662.51c-.805.045-1.28.643-1.45 1.15a1.878 1.878 0 0 0 .264 1.708c.035.047.073.09.115.13l2.687 2.601-.605 3.717c-.268 1.427 1.168 2.403 2.392 1.914a1.09 1.09 0 0 0 .093-.043l3.398-1.742 3.398 1.742.01.005c.67.335 1.361.123 1.78-.184.435-.32.837-.93.695-1.691l-.605-3.718 2.687-2.6.013-.013a1.82 1.82 0 0 0 .47-1.772c-.156-.56-.651-1.16-1.455-1.203l-3.762-.513-1.628-3.344ZM23.464 32.81l-9.5-4.1.872-2.02 9.444 4.076a.275.275 0 0 0 .14 0l9.444-4.076.872 2.02-9.5 4.1a2.487 2.487 0 0 1-1.772 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.568 39.012-9.6-4.1.864-2.023 9.546 4.077c.05.012.093.013.142 0l9.444-4.076.872 2.02-9.5 4.1a2.487 2.487 0 0 1-1.768.002Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_military_light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(14 9)",
    d: "M0 0h20.9v30.2H0z"
  })))));
};
export default SvgIconMilitaryLight;